import React, { Component } from "react";
import Header from "../component/layout/header";
import FooterSection from "../component/layout/footer";
import BannerSection from "../component/section/banner";
import MemberSection from "../component/section/member";
import AboutSection from "../component/section/about";
import StorySection from "../component/section/storysection";
import WorkSection from "../component/section/work";
import MemberTwoSection from "../component/section/memberTwo";
import GroupSection from "../component/section/group";
import ClientSection from "../component/section/clints";
import AppsSection from "../component/section/apps";
import MobileFooter from "../component/layout/mobilefooter";
import { Helmet } from "react-helmet";
import PWAInstallModal from "../component/models/pwamodel";

class HomePages extends Component {
  render() {
    const ogImage = `${window.location.origin}/assets/images/logo/logo.png`;
    const ogTitle = "Connect & Share – A Unique Social Community";
    const ogDescription =
      "Join our unique social platform where you can share your ideas, feelings, and connect with like-minded people. Discover new friendships, meaningful connections, and express yourself freely.";

    return (
      <div>
        <Helmet>
          <title>{ogTitle}</title>
          <meta name="description" content={ogDescription} />

          {/* Open Graph */}
          <meta property="og:title" content={ogTitle} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="website" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={ogTitle} />
          <meta name="twitter:description" content={ogDescription} />
          <meta name="twitter:image" content={ogImage} />
        </Helmet>
        <Header />

        <PWAInstallModal />

        <BannerSection />
        <MemberSection />
        <AboutSection />
        {/* <WorkSection /> */}
        <StorySection />
        <MemberTwoSection />
        <GroupSection />
        {/* <ClientSection /> */}
        <AppsSection />
        <FooterSection />
      </div>
    );
  }
}

export default HomePages;
